/**
 *  Created by piotr@revisual.io on 11/08/2025
 */
import LoadingIndicator from "../component/LoadingIndicator";
import { Link, useHistory, useLocation } from "react-router-dom";
import appConfig from "../../../appConfig";
import React, { useEffect } from "react";
import { useUserStore } from "../../../hooks/redux/user";
import { useCurrentOrganizationStore } from "../../../hooks/redux/currentOrganization";
import { hasOnboardingCompleted } from "../helpers/organization";

export const RedirectPage = () => {
  const { user } = useUserStore();
  const history = useHistory();
  const [redirected, setRedirected] = React.useState(false);
  const location = useLocation();
  // console.log("RedirectPage location", location);

  const { currentOrganization } = useCurrentOrganizationStore();

  useEffect(() => {
    if (!redirected) {
      setRedirected(true);

      // console.log("RedirectPage useEffect", user.model);

      // if (history.location.pathname.localeCompare("/") === 0) {
      if (user.model) {
        if (!user.model.is_account_verified) {
          // allow accessing any pathname that has token= query param
          if (/.*token=.*/.test(location.search)) {
            return;
          }

          history.push("/verify-email");
        } else {
          const onboardingComplete =
            hasOnboardingCompleted(currentOrganization);

          if (
            !onboardingComplete &&
            (user.loginSuccess || user.checkSessionSuccess) &&
            user.model &&
            user.model?.is_account_verified &&
            history.location.pathname !== "/onboarding"
          ) {
            // redirect to onboarding page if not completed
            history.push("/onboarding", { replace: true });
            return;
          } else {
            if (history.location.pathname.localeCompare("/") === 0) {
              history.push("/dashboard");
            }
          }
        }
      } else {
        const invitationPathRegex = /^\/accept_invitation/;
        const isInvitationPage = invitationPathRegex.test(
          window.location.pathname
        );

        // Exit if on invitation page
        if (isInvitationPage) {
          return;
        }

        // console.log(
        //   "testing if onboarding with token",
        //   history.location,
        //   window.location
        // );
        if (/.*token=.*/.test(location.search)) {
          // console.log("yes, onboarding with token");
          return;
        }

        const allowedPathsWithoutAuth = [
          /^\/login/,
          /^\/register/,
          /^\/password-reminder/,
          /^\/password-reset/,
          /^\/account-verification/,
          /^\/verify-email/,
          /^\/$/,
        ];

        if (
          !allowedPathsWithoutAuth.find((i) =>
            history.location.pathname.match(i)
          )
        ) {
          window.location =
            "/login/?redirect=" +
            encodeURIComponent(
              window.location.pathname + window.location.search
            );

          // history.push(
          //   "/login/?redirect=" +
          //     encodeURI(window.location.pathname + window.location.search)
          // );
        }

        if (history.location.pathname.localeCompare("/") === 0) {
          history.push("/login");
        }
      }
    }
    // }
  }, [
    currentOrganization.model?.organization_settings,
    history,
    redirected,
    user.checkSessionSuccess,
    user.loginSuccess,
    user.model,
    location,
  ]);

  if (redirected) {
    return null;
  }
  return (
    <div className="main-wrapper">
      <div className="account-page">
        <div className="container">
          <div className="account-logo">
            <Link to="/">
              <img
                src={`/img/branding/${appConfig.branding}/full_length_logo_frontier.png`}
                alt={appConfig.displayName}
              />
            </Link>
          </div>
          <div>
            <LoadingIndicator />
          </div>
        </div>
      </div>
    </div>
  );
};

export default RedirectPage;
